import { AppConfiguration } from "config"
import { call, put, takeEvery } from "redux-saga/effects"
import { EXPORT_CALLS_ON_EMAIL, EXPORT_INVOICES_ON_EMAIL, EXPORT_LEADS_ON_EMAIL, EXPORT_PROSPECTS_ON_EMAIL, EXPORT_RECEIPTS_ON_EMAIL } from "./actionTypes"
import { exportCallsOnEmailError, exportCallsOnEmailSuccess, exportInvoicesOnEmailError, exportInvoicesOnEmailSuccess, exportLeadsOnEmailError, exportLeadsOnEmailSuccess, exportProspectsOnEmailError, exportProspectsOnEmailSuccess, exportReceiptsOnEmailError, exportReceiptsOnEmailSuccess } from "./actions"
import { genericPostRequest } from "../../helpers/sf_backend_helper"
import { bsh_getClientUserDetails, bsh_isAdminUserDetailsPresent } from "helpers/sf_browser_storage_helper"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"
import { showExportEnqueuedToast } from "helpers/export_toast_helper"

function* onExportLeadsOnEmail(action) {
    let user = bsh_getClientUserDetails();
    const url = `${AppConfiguration.BACKEND_URL}/api/v1/email_export/leads`
    const req = {
        body: JSON.stringify(action.payload?.queryParams),
        headers: {
            'Authorization': user.token,
            'account-id': user.account_id,
            'Content-Type': 'application/json',
        }
    }
    try {
        const response = yield call(genericPostRequest, url, req)
        yield put(exportLeadsOnEmailSuccess(response))
        showExportEnqueuedToast({ reportExportsAvailable: bsh_isAdminUserDetailsPresent() });
    } catch (error) {
        yield put(exportLeadsOnEmailError(error))
    }
}

function* onExportCallsOnEmail(action) {
    let user = bsh_getClientUserDetails();
    const url = `${AppConfiguration.BACKEND_URL}/api/v1/email_export/calls`
    const req = {
        body: JSON.stringify(action.payload?.queryParams),
        headers: {
            'Authorization': user.token,
            'account-id': user.account_id,
            'Content-Type': 'application/json',
        }
    }
    try {
        const response = yield call(genericPostRequest, url, req)
        yield put(exportCallsOnEmailSuccess(response))
        showExportEnqueuedToast({ reportExportsAvailable: bsh_isAdminUserDetailsPresent() });
    } catch (error) {
        yield put(exportCallsOnEmailError(error))
    }
}

function* onExportProspectsOnEmail(action) {
    let user = bsh_getClientUserDetails();
    const url = `${AppConfiguration.BACKEND_URL}/api/v1/email_export/prospects`
    const req = {
        body: JSON.stringify(action.payload?.queryParams),
        headers: {
            'Authorization': user.token,
            'account-id': user.account_id,
            'Content-Type': 'application/json',
        }
    }
    try {
        const response = yield call(genericPostRequest, url, req)
        yield put(exportProspectsOnEmailSuccess(response))
        showExportEnqueuedToast({ reportExportsAvailable: bsh_isAdminUserDetailsPresent() });
    } catch (error) {
        yield put(exportProspectsOnEmailError(error))
    }
}

function* onExportInvoicesOnEmail(action) {
    let user = bsh_getClientUserDetails();
    const url = `${AppConfiguration.BACKEND_URL}/api/v1/email_export/invoices`
    const req = {
        body: JSON.stringify(action.payload?.queryParams),
        headers: {
            'Authorization': user.token,
            'account-id': user.account_id,
            'Content-Type': 'application/json',
        }
    }
    try {
        const response = yield call(genericPostRequest, url, req)
        yield put(exportInvoicesOnEmailSuccess(response))
        showExportEnqueuedToast();
    } catch (error) {
        yield put(exportInvoicesOnEmailError(error))
    }
}

function* onExportReceiptsOnEmail(action) {
    let user = bsh_getClientUserDetails();
    const url = `${AppConfiguration.BACKEND_URL}/api/v1/email_export/receipts`
    const req = {
        body: JSON.stringify(action.payload?.queryParams),
        headers: {
            'Authorization': user.token,
            'account-id': user.account_id,
            'brand-id': getCurrentBrandFromLocalStorage()?.id,
            'Content-Type': 'application/json',
        }
    }
    try {
        const response = yield call(genericPostRequest, url, req)
        yield put(exportReceiptsOnEmailSuccess(response))
        showExportEnqueuedToast();
    } catch (error) {
        yield put(exportReceiptsOnEmailError(error))
    }
}

function* ExportEmailSaga() {
    yield takeEvery(EXPORT_LEADS_ON_EMAIL, onExportLeadsOnEmail)
    yield takeEvery(EXPORT_CALLS_ON_EMAIL, onExportCallsOnEmail)
    yield takeEvery(EXPORT_PROSPECTS_ON_EMAIL, onExportProspectsOnEmail)
    yield takeEvery(EXPORT_INVOICES_ON_EMAIL, onExportInvoicesOnEmail)
    yield takeEvery(EXPORT_RECEIPTS_ON_EMAIL, onExportReceiptsOnEmail)
}

export default ExportEmailSaga;
